/**********************************************************************
 * Generated by RxDjango on 2026-07-16 17:04 (UTC)                    *
 *                                                                    *
 * Based on all ContextChannel subclasses in static_queryset.channels *
 *                                                                    *
 *                        DO NOT EDIT THIS FILE                       *
 *                                                                    *
 * To rebuild it, run:                                                *
 *                                                                    *
 *     ./manage.py makefrontend [static_queryset]                     *
 *                                                                    *
 **********************************************************************/

import { ContextChannel } from '@rxdjango/react';
import type { Task } from './static_queryset.models';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class StaticQuerysetChannel extends ContextChannel {

  protected endpoint: string = "/ws/static_queryset/";
  protected baseURL: string = SOCKET_URL;

  tasks: Task[] | null = null;

  protected _modelFields: Record<string, {
      anchor: string;
      model: Record<string, Record<string, string>>;
      many?: boolean;
    }> = {
      "tasks": {
        anchor: "static_queryset.serializers.TaskSerializer",
        many: true,
        model: {
          "static_queryset.serializers.TaskSerializer": {  },
        },
      },
    };

  rebind = async () => {
    return await this.rx.callAction('rebind', []);
  };

  toggle_status = async (task_id: number) => {
    return await this.rx.callAction('toggle_status', [task_id]);
  };

  bump_priority = async (task_id: number, delta: number) => {
    return await this.rx.callAction('bump_priority', [task_id, delta]);
  };

  delete_task = async (task_id: number) => {
    return await this.rx.callAction('delete_task', [task_id]);
  };

  add_task = async (name: string, priority: number) => {
    return await this.rx.callAction('add_task', [name, priority]);
  };
}
